import { render, staticRenderFns } from "./EventIcon.vue?vue&type=template&id=6ce79250&scoped=true&"
import script from "./EventIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EventIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce79250",
  null
  
)

export default component.exports